export const apiSignature = {
    SERVICE_LIST : "service/fetchServiceList",
    SERVICE_ADD_CATEGORY:'service/addServiceCategoryAPI',
    SERVICE_ADD_SUB_CATEGORY:'service/addServiceSubCategoryAPI',
    UPDATE_SERVICE_CATEGORY:'updateServiceCategoryAPI',
    UPDATE_SERVICE:'updateServiceSubCategoryAPI',
    UPDATE_CATEGORY_STATUS:'updateCategoryStatusAPI',
    UPDATE_SERVICE_STATUS:'updateSubCategoryStatusAPI',
    DELETE_CATEGORY:'deleteServiceCategoryAPI',
    DELETE_SERVICE:'deleteServiceSubCategoryAPI'
}